import React, { useEffect, useRef, useState } from "react";
import { Card, Input, Button, Breadcrumb, Select } from "../../../../../common";
import { ReactComponent as Spinner } from "../../../../../../assets/icons/spinner.svg";
import { geoNames } from "../../../../../../utils/countriesGeonames";
import { fetchStates } from "../../../../../../utils/Helper";
import { useSelector } from "react-redux";
import { getCountryCode, getStatesByCountryCode } from "../../../../../../utils/countriesState";

export const AddCompanyName = ({
  handleAddNewCompany = () => { },
  breadNext,
  breadPrev,
  label,
  handleCompanySubmit,
  isLoading,
  handleSelectedCompany = () => { }
}) => {
  const companyName = useRef();
  const countries = getCountryCode();
  const [states, setStates] = useState([]);
  const [isLoadingState, setIsLoadingState] = useState(false);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [errors, setErrors] = useState({});

  const { currentEditingCompany } = useSelector((state) => state.company);

  const handleCountryChange = (e) => {
    setSelectedCountry(e.target.value); const selectedCountryData = countries.find(
      (country) => country.countryCode === e.target.value
    );

    if (selectedCountryData) {
      let statesFn = async () => {
        setIsLoadingState(true);
        const states = await getStatesByCountryCode(selectedCountryData?.countryCode);
        if (states) {
          setStates(states);
        }
        setIsLoadingState(false);
      };
      statesFn();
    }
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setSelectedState(selectedState);
  };

  const validateErrors = () => {
    const errors = {};
    if (selectedState.trim() === "") {
      errors.state = "State is required.";
    }
    if (selectedCountry.trim() === "") {
      errors.country = "Country is required.";
    }
    if (companyName.current.value.trim() === "") {
      errors.companyName = "Business Name is required.";
    }

    return errors
  }

  useEffect(() => {
    const entityData = {
      country: selectedCountry,
      name: companyName.current.value,
      state: selectedState
    };
    handleSelectedCompany(entityData);
  }, [selectedState, selectedCountry, companyName?.current])

  const handleSubmit = (e) => {
    const errors = validateErrors();
    setErrors(errors);
    const entityData = {
      country: selectedCountry,
      // companyID: currentEditingCompany?.companyID,
      name: companyName.current.value,
      state: selectedState
    };
    if (Object.keys(errors).length === 0) {
      handleCompanySubmit(entityData);
    }
  };

  return (
    <Card classes="rounded bg-white p-4 w-[34rem] text-left">
      <Breadcrumb
        onClick={handleAddNewCompany}
        prev={breadPrev}
        next={breadNext}
      />
      <div className="relative">
        <div>
          <Input
            label={"Business Name"}
            id="name"
            inputRef={companyName}
            error={errors.companyName}
            placeholder="Enter Business Name"
          />
          <div className="mb-4 w-full">
            <Select
              label="Country"
              id="country"
              value={selectedCountry}
              error={errors.country}
              placeholder="Select a country"
              onChange={handleCountryChange}
            >
              <option value="">Select a country</option>
              {geoNames?.sort((a, b) => a.countryName.localeCompare(b.countryName)).map((country) => (
                <option key={country.countryName} value={country.countryCode}>
                  {country.countryName}
                </option>
              ))}

            </Select>
          </div>
          <div className="mb-4 w-full">
            {isLoadingState ? <Spinner /> : states?.length > 0 ? <Select
              label="State"
              id="state"
              value={selectedState}
              onChange={handleStateChange}
              error={errors.state}
              disable={!selectedCountry}
              placeholder="Select a state"
              className={!selectedCountry ? "cursor-not-allowed" : "default"}
            >
              <option value="">Select a state</option>
              {states?.map((state) => (
                <option key={state.state_code} value={state.name}>
                  {state.name}
                </option>
              ))}
            </Select> : <Input
              label="State"
              id="state"
              inputvalue={selectedState}
              onInputChange={handleStateChange}
              error={errors.state}
              placeholder="Enter a state"
              disable={!selectedCountry}
              className={!selectedCountry ? "cursor-not-allowed" : "default"}
            />}
          </div>

          <Button
            onClick={handleSubmit}
            classes="w-full p-2 bg-primary text-white rounded text-f18 mt-4 flex items-center justify-center"
          >
            {isLoading ? <Spinner /> : "Submit"}
          </Button>
        </div>
        {/* <div className="absolute top-0 left-0 w-full h-full bg-opacity-75 flex flex-col items-center justify-center z-10">
          <h1 className="text-xl font-bold text-gray-700 mb-4 mb-5 uppercase">Coming Soon</h1>
          <Button
            onClick={handleAddNewCompany}
            classes="w-full p-2 bg-primary text-white rounded text-f18 flex items-center justify-center"
          >
            {isLoading ? <Spinner /> : "Go Back"}
          </Button>
        </div> */}
      </div>
    </Card>
  );
};
